 
import { useQuery } from 'react-query';

import api from '@api/instance';
import { Page } from '@models/page';
import { NOOP } from '@testsigma/atoms';

import { SalesforceMetadataSyncResult } from '@modules/salesforce/models';

import { findAllProps, useCommonFindAllProps } from './common-types';

const nameSpace = '/salesforce_metadata_sync_result';

const show = (connectionId: number) => {
  return api
    .get(nameSpace + '/metadata_connection/' + connectionId)
    .then((res) => new SalesforceMetadataSyncResult().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const findAll = (query?, size?, page?, sort?) => {
  return api
    .get(nameSpace, {
      query,
      size,
      page,
      sort,
    })
    .then((res) =>
      new Page<SalesforceMetadataSyncResult>().deserialize(
        res,
        SalesforceMetadataSyncResult,
      ),
    )
    .catch((e) => Promise.reject(e));
};

const useFindAll = ({
  payload,
  key = null,
  callback,
  beforeQuery = NOOP,
}: useCommonFindAllProps) => {
  return useQuery({
    queryKey: key || payload,
    queryFn: () => {
      beforeQuery();
      return findAll(payload.query, payload.sort, payload.size, payload.page);
    },
    onSuccess: (data) => callback(true, data),
    onError: (err) => callback(false, err),
  });
};

const SalesforceMetadataSyncResultService = {
  show,
  findAll,
  useFindAll,
};

export default SalesforceMetadataSyncResultService;
